import { defineStore } from "pinia";
import postetSevice from "@/services/Postet/postet.sevice";

export const usePostsStore = defineStore("postStore", {
  state: () => ({
    posts: [], // For multiple posts
    post: [], // For single post
    loading: false,
    error: null,
    leftPosts: [], // For NewsTemplateLeft
    rightPosts: [], // For NewsTemplateRight
    raportetPosts: [],
    videoPosts: [],
    mundesiPunesimiPosts: [],
    agendaPosts: [],
    buletins: [],
  }),

  actions: {
    formatDate(dateString) {
      if (!dateString) return "";

      const isoString = dateString.replace(" ", "T").split(".")[0];

      const date = new Date(isoString);
      if (isNaN(date)) return "";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    },

    async getPosts(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        return (this.posts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getPostsLeft(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        return (this.leftPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
    async getBuletins(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        return (this.buletins = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getPostsRight(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        return (this.rightPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getRaportetPosts(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategoryReports(postsData);
        return (this.raportetPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          htmlContent: post.htmlContent,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getVideoPosts(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        return (this.videoPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },
    async getMundesiPunesimiPosts(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        this.mundesiPunesimiPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          createdDate: post.createdDate, // LËRE SI ËSHTË (ISO string)
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          deadlineDate: post.deadlineDate, // LËRE SI ËSHTË
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
          competitionTypeId: post.competitionTypeId,
          competitionTypeName: post.competitionTypeName,
        }));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async getGetAgenda(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsCategory(postsData);
        // Map API response to a normalized structure for the calendar
        return (this.agendaPosts = response.map((post) => ({
          id: post.id,
          webPage: post.webPage,
          // Keep both ISO and formatted date for flexibility
          createdDate: post.createdDate, // ISO string for grouping
          formattedDate: this.formatDate(post.createdDate), // dd.MM.yyyy for display
          categoryName: post.categoryName,
          title: post.priceDetailsTitle,
          description: post.pDetailsContent,
          language: post.pDetailsLanguage,
          fileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" +
              post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
          competitionTypeId: post.competitionTypeId,
          competitionTypeName: post.competitionTypeName,
        })));
      } catch (err) {
        this.error = err.message;
      } finally {
        this.loading = false;
      }
    },

    async fetchPosts() {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPosts();
        this.posts = response;
        return this.posts;
      } catch (err) {
        this.error = err.response?.data?.message || "Failed to fetch posts";
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async getPostById(postsData) {
      this.loading = true;
      this.error = null;
      try {
        const response = await postetSevice.getPostsById(postsData);
        const post =
          Array.isArray(response) && response.length > 0 ? response[0] : null;

        if (!post) {
          throw new Error("No post found");
        }

        // Mapo postin dhe ruaje në state
        this.post = {
          id: post.id,
          webPage: post.webPage,
          createdDate: this.formatDate(post.createdDate),
          categoryName: post.categoryName,
          priceDetailsTitle: post.priceDetailsTitle,
          pDetailsContent: post.pDetailsContent,
          pDetailsLanguage: post.pDetailsLanguage,
          htmlContent: post.htmlContent,
          pDetailsFileUrl: post.pDetailsFileUrl
            ? "https://prokuroria-rks.org/uploads/" + post.pDetailsFileUrl
            : "https://prokuroria-rks.org/uploads/2025/06/8296c08f-d762-4c9d-acde-573c76082ced_PSRK-1-scaled.jpg",
        };

        return this.post;
      } catch (err) {
        console.error("Error fetching post:", err);
        this.error = err.message || "Failed to fetch post";
        return null;
      } finally {
        this.loading = false;
      }
    },

    // Other actions (getPosts, getPostsLeft, etc.) remain unchanged
  },
});
